import "./App.css";
import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Dashboard from "./pages/dashboard";
import { useEffect } from "react";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import { Toaster } from "react-hot-toast";
import AccountApproval from "./pages/account-approval";
import OTPInput from "./pages/otp";
import ForgetPassword from "./pages/forget-password";
import NewPassword from "./pages/new-password";
import OTPPasswordReset from "./pages/otp-password-reset";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <main className="w-full">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/account-approval" element={<AccountApproval />} />
        <Route path="/otp" element={<OTPInput />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/otp-password-reset" element={<OTPPasswordReset />} />
        <Route path="/change-password" element={<NewPassword />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>

      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#333",
            color: "#fff",
          },
          success: {
            iconTheme: {
              primary: "green",
              secondary: "white",
            },
          },
        }}
      />
    </main>
  );
}

export default App;
